import React, { useEffect, useState, useRef } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box,
    CircularProgress,
    Button,
    Skeleton,
    Dialog,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemButton,
    Divider,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Snackbar,
    Alert,
} from "@mui/material";
import {
    Menu as MenuIcon,
    ArrowBackIos,
    Download as DownloadIcon,
} from "@mui/icons-material";
import StarRateIcon from "@mui/icons-material/StarRate";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import subjectIcon from "../../../src/svg/subject.svg";
import categoriesIcon from "../../../src/svg/categories.svg";
import authorIcon from "../../../src/svg/author.svg";
import languageIcon from "../../../src/svg/language.svg";
import latestIcon from "../../../src/Images/LatestIcon.png";
import eBooksIcon from "../../../src/svg/ebook.svg";
import magazinesIcon from "../../../src/svg/magazineHome.svg";
import videoIcon from "../../../src/svg/ic_video_home.svg";
import pravachanIcon from "../../../src/svg/pravachanHome.svg";
import audioIcon from "../../../src/svg/audioHome.svg";
import dailySatsangIcon from "../../../src/svg/DailySatsang.svg";
import amritVachanIcon from "../../../src/svg/articlesHome.svg";
import latestSeenIcon from "../../../src/svg/recentlyViewed.svg";
import myFavoriteIcon from "../../../src/svg/favoritesHome.svg";
import contactUsIcon from "../../../src/svg/contactUs.svg";
import shareIcon from "../../../src/svg/social.svg";
import whatsappIcon from "../../../src/svg/whatsappPrimary.svg";
import youtubeIcon from "../../svg/youtubeIcon.svg";
import facebookIcon from "../../svg/facebookIcon.svg";
import twitterIcon from "../../svg/xTwitterIcon.svg";
import instagramIcon from "../../svg/ic_instagram.svg";
import whatsappGroupIcon from "../../svg/whatsappChannel.svg";
import MobileDrawer from "./MobileDrawer";
import SubjectService from "../../Services/Subjects";
import BooksService from "../../Services/Books";
import KalyansService from "../../Services/Kalyan";
import KalpataruService from "../../Services/Kalpataru";
import VivekvaniServices from "../../Services/Vivekvani";
import { useNavigate } from "react-router-dom";
import { hideMobileSplash } from "../../utils/hideMobileSplash";
import AudioService from '../../Services/Audios';
import PravachanService from '../../Services/Pravachans';
import VideoService from '../../Services/VideoPlayer';
import ArticlesService from '../../Services/Articles';
import authorService from '../../Services/Authors';
import { ArticleItem, AudioItem, CategoriesAccordion, CategoryItem, KalpataruItem, KalyansItem, PravachanItem, VideoItem, VivekVaniItem } from "./CategoriesAccordion";
import AuthorsAccordion from "./AuthorsAccordion";
import LanguageAccordion from "./LanguageAccordion";
import HomeServices from "../../Services/Home";
import Carousel from 'react-material-ui-carousel';
import GeetGovindServices from "../../Services/GeetGovind";
// import gitasevaLogo from "../../svg/gitasevaLogo.svg";
import gitasevalogo from "../../Images/logoGST_app_icon.png";
import Latest from "./Latest";
import { useDownloadApp } from "../../Contexts/DownloadAppContext";
import {
    clearLcpBannerHint,
    preloadLcpBannerHint,
    removeLcpBannerPreload,
    saveLcpBannerHint,
} from "../../utils/lcpBannerHint";
import { applyBannerNavigation } from "../../utils/bannerNavigation";
import { copyShareUrl, HOME_SHARE_URL } from "../../utils/copyShareUrl";

export function MobileHome() {
    const { t } = useTranslation();
    const [carouselIndex, setCarouselIndex] = React.useState(0);
    const [banners, setBanners] = React.useState<any[]>([]);
    const [loadingBanners, setLoadingBanners] = React.useState<boolean>(true);
    const [openDrawer, setOpenDrawer] = useState<boolean>(false);
    const [openSubjectDiv, setOpenSubjectDiv] = useState<boolean>(false);
    const [openCategoriesDiv, setOpenCategoriesDiv] = useState<boolean>(false);
    const [openAuthorsDiv, setOpenAurhorsDiv] = useState<boolean>(false);
    const [openLanguageDiv, setOpenLanguageDiv] = useState<boolean>(false);
    const [activeMenuItem, setActiveMenuItem] = useState<string | null>(null);
    const [productFor, setProductFor] = useState<string>("");
    const [subjects, setSubjects] = useState<any[]>([]);
    const [loadingSubjects, setLoadingSubjects] = useState<boolean>(false);
    const [categories, setCategories] = useState<CategoryItem[]>([]);
    const [kalyans, setKalyans] = useState<KalyansItem[]>([]);
    const [kalpataru, setKalpataru] = useState<KalpataruItem[]>([]);
    const [vivekVani, setVivekVani] = useState<VivekVaniItem[]>([]);
    const [loadingCategories, setLoadingCategories] = useState<boolean>(false);
    const [audios, setAudios] = useState<AudioItem[]>([]);
    const [loadingAudios, setLoadingAudios] = useState<boolean>(false);
    const [pravachans, setPravachans] = useState<PravachanItem[]>([]);
    const [loadingPravachans, setLoadingPravachans] = useState<boolean>(false);
    const [videos, setVideos] = useState<VideoItem[]>([]);
    const [loadingVideos, setLoadingVideos] = useState<boolean>(false);
    const [articles, setArticles] = useState<ArticleItem[]>([]);
    const [authors, setAuthors] = useState<any[]>([]);
    const [loadingAuthors, setLoadingAuthors] = useState<boolean>(false);
    const [loadingArticles, setLoadingArticles] = useState<boolean>(false);
    const [audioAuthors, setAudioAuthors] = useState<any[]>([]);
    const [articlesAuthors, setArticlesAuthors] = useState<any[]>([]);
    const [videoAuthors, setVideoAuthors] = useState<any[]>([]);
    const [languages, setLanguages] = useState<any[]>([]);
    const [loadingLanguages, setLoadingLanguages] = useState<boolean>(false);
    const appBarRef = useRef<HTMLDivElement>(null);
    const loadingStartSubjects = useRef<number>(0);
    const loadingStartAuthors = useRef<number>(0);
    const loadingStartLanguages = useRef<number>(0);
    const MIN_SKELETON_MS = 500;
    const [appBarHeight, setAppBarHeight] = useState(0);
    const [magazine, setMagazine] = useState<any[]>([]);
    const [openLatestDiv, setOpenLatestDiv] = useState<boolean>(false);
    const [bannerDismissed, setBannerDismissed] = useState<boolean>(false);
    const { setShowDownloadPopup } = useDownloadApp();
    const [languageModal, setLanguageModal] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("language") || 'hindi');
    const [contactModal, setContactModal] = useState(false);
    const [contactData, setContactData] = useState({
        name: localStorage.getItem("UserName") || "",
        phoneNumber: localStorage.getItem("Phone") || "",
        email: localStorage.getItem("Email") || "",
        messageContent: "",
        contactType: "1",
    });
    const [contactError, setContactError] = useState<{
        name?: string; number?: string; email?: string; note?: string; captcha?: string;
    }>({});
    const [contactStep, setContactStep] = useState(1);
    const contactTypes = [
        { value: "1", labelKey: "generalQuery_tr" },
        { value: "2", labelKey: "E_books_tr" },
        { value: "3", labelKey: "Audios_tr" },
        { value: "4", labelKey: "Pravachan_tr" },
        { value: "5", labelKey: "Article_tr" },
        { value: "6", labelKey: "Kalyan_tr" },
        { value: "7", labelKey: "Kalyan_Kalpataru_tr" },
        { value: "8", labelKey: "MonthlyMagazine_tr" },
        { value: "9", labelKey: "vivek_vani_tr" },
        { value: "10", labelKey: "other_tr" },
    ];
    const [compareCaptcha, setCompareCaptcha] = useState("");
    const [captchaValue, setCaptchaValue] = useState("");
    const [showContactSuccess, setShowContactSuccess] = useState(false);
    const contactScrollRef = useRef<HTMLDivElement>(null);
    const nameRef = useRef<HTMLInputElement>(null);
    const numberRef = useRef<HTMLInputElement>(null);
    const emailRef = useRef<HTMLInputElement>(null);
    const messageRef = useRef<HTMLTextAreaElement>(null);
    const captchaRef = useRef<HTMLInputElement>(null);
    const [socialModal, setSocialModal] = useState(false);
    const [linkCopiedSnack, setLinkCopiedSnack] = useState(false);

    /** Home share (2nd footer): copy mobileweb deep-link and show snackbar */
    const handleHomeShareClick = async () => {
        const logdetails: string[] = [];
        logdetails.push("action=home_share");
        logdetails.push(`url=${HOME_SHARE_URL}`);
        const ok = await copyShareUrl(HOME_SHARE_URL);
        logdetails.push(`copied=${ok}`);
        console.log("MobileHome -> handleHomeShareClick ->", logdetails.join(" | "));
        if (ok) setLinkCopiedSnack(true);
    };

    const toggleDrawer = (open: boolean) => () => {
        setOpenDrawer(open);
    };
    const navigate = useNavigate();

    const closeAllContentDivs = () => {
        setOpenSubjectDiv(false);
        setOpenCategoriesDiv(false);
        setOpenAurhorsDiv(false);
        setOpenLanguageDiv(false);
        setOpenLatestDiv(false);
        setActiveMenuItem(null);
    };

    const handleNavigation = (path: string | undefined, label: string) => {
        closeAllContentDivs();
        if (label === t("Subject_tr")) {
            setOpenSubjectDiv(true);
            setActiveMenuItem(label);
        } else if (label === t("Categoriesss_tr")) {
            setOpenCategoriesDiv(true);
            setActiveMenuItem(label);
        } else if (label === t("Authors_tr")) {
            setOpenAurhorsDiv(true);
            setActiveMenuItem(label);
        } else if (label === t("Language_tr")) {
            setOpenLanguageDiv(true);
            setActiveMenuItem(label);
        }
        else if (label === t("Latest_tr")) {
            setOpenLatestDiv(true);
            setActiveMenuItem(label);
        }
        else if (label === t("daily_satsang_tr")) {
            navigate("/DailySatsang", { state: { type: "DailySatsang", sortOption: "2" } });
            setActiveMenuItem(null);
        }
        else if (path === "/downloadAppPage") {
            setShowDownloadPopup(true);
            setActiveMenuItem(null);
        }
        else if (path) {
            navigate(path);
            setActiveMenuItem(null);
        }
    };

    const handleChangeLanguage = (lang: string) => {
        setSelectedLanguage(lang);
        localStorage.setItem("language", lang);
        localStorage.setItem("lan", lang === "hindi" ? "hi" : "en");
        i18n.changeLanguage(lang === "hindi" ? "hi" : "en");
        setLanguageModal(false);
    };

    const generateCaptcha = (length: number) => {
        const characters = "abc123";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        setCompareCaptcha(result);
    };

    const handleContactSubmit = () => {
        const newErrors: typeof contactError = {};
        if (!contactData.name?.trim()) newErrors.name = "Please enter a valid name";
        if (!contactData.phoneNumber?.trim()) newErrors.number = "Please enter a valid mobile number";
        // if (!contactData.email?.trim() || !contactData.email.match("[a-z0-9]+@[a-z]+.[a-z]{2,3}")) newErrors.email = "Please enter a valid email address";


        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!contactData.email?.trim() || !emailRegex.test(contactData.email.trim())) {
            newErrors.email = "Please enter a valid email address";
        }


        if (!contactData.messageContent?.trim()) newErrors.note = "Please enter a valid message";
        if (captchaValue !== compareCaptcha) newErrors.captcha = "Please enter a valid captcha";

        setContactError(newErrors);

        if (Object.keys(newErrors).length > 0) {
            setTimeout(() => {
                if (newErrors.name) nameRef.current?.focus();
                else if (newErrors.number) numberRef.current?.focus();
                else if (newErrors.email) emailRef.current?.focus();
                else if (newErrors.note) messageRef.current?.focus();
                else if (newErrors.captcha) captchaRef.current?.focus();
            }, 100);
            return;
        }

        HomeServices.postcontact({ ...contactData, contactType: parseInt(contactData.contactType), medium: 1, userId: "", deviceDetails: "" }).then((result: any) => {
            if (result.status) {
                setShowContactSuccess(true);
                setCaptchaValue("");
                setContactData({
                    name: localStorage.getItem("UserName") || "",
                    phoneNumber: localStorage.getItem("Phone") || "",
                    email: localStorage.getItem("Email") || "",
                    messageContent: "",
                    contactType: "1",
                });
            }
        });
    };

    const handleMessageFocus = () => {
        setTimeout(() => {
            contactScrollRef.current?.scrollTo({
                top: contactScrollRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }, 300);
    };

    const options = [
        { label: t("E_books_tr"), icon: <img src={eBooksIcon} height={25} width={25} alt="E-books" />, path: "/books" },
        {
            label: (
                <>
                    {t("magazine_tr")}
                    <span style={{ fontSize: '0.85em', color: '#6c757d', display: 'block' }}>
                        ({t("inc.geetGovind_tr")})
                    </span>
                </>
            ),
            icon: <img src={magazinesIcon} height={25} width={25} className="mt-2" alt="Magazines" />,
            path: "/magazines"
        },
        { label: t("Video_tr"), icon: <img src={videoIcon} height={30} width={30} alt="Video" />, path: "/video" },
        { label: t("Pravachan_tr"), icon: <img src={pravachanIcon} height={30} width={30} alt="Pravachan" />, path: "/pravachans" },
        { label: t("Audios_tr"), icon: <img src={audioIcon} height={30} width={30} alt="Audios" />, path: "/audios" },
        { label: t("daily_satsang_tr"), icon: <img src={dailySatsangIcon} height={30} width={30} alt="Daily Satsang" />, path: "/downloadAppPage" },
        { label: t("Amrit_Vachan_tr"), icon: <img src={amritVachanIcon} height={30} width={30} alt="Amrit Vachan" />, path: "/divineQuotes" },
        { label: t("Recent_Seen"), icon: <img src={latestSeenIcon} height={30} width={30} alt="Recently Seen" />, path: "/downloadAppPage" },
        { 
            label: <>
                {t("myFavourites_tr")}
                <br />
                {t("myFavourites_tr_1")}
            </>, icon: <img src={myFavoriteIcon} height={30} width={30} alt="My Favorites" />, path: "/downloadAppPage"
        },
    ];

    // Hide mobile splash screen when MobileHome paints.
    // The helper keeps the same fade timing while avoiding duplicate DOM logic.
    useEffect(() => {
        const logdetails: string[] = ['mobile-home splash dismiss'];
        hideMobileSplash('MobileHome', logdetails);
    }, []);

    // Preload last first-banner URL as a download hint only; paint from live API.
    useEffect(() => {
        const lang = localStorage.getItem('lan') || 'en';
        preloadLcpBannerHint(lang);

        let cancelled = false;
        let idleId: number | undefined;
        let timeoutId: number | undefined;

        const applyBanners = (result: any[]) => {
            setBanners(result);
            const firstUrl = result[0]?.bannerPath;
            if (firstUrl) {
                saveLcpBannerHint(firstUrl, lang);
            }
        };

        const fetchBanners = async (length: number) => {
            const response = await HomeServices.getbanners(lang, length);
            if (cancelled) return;
            if (response?.status && Array.isArray(response.result)) {
                applyBanners(response.result);
            } else if (length === 2) {
                setBanners([]);
            }
        };

        const loadRest = () => {
            if (cancelled) return;
            fetchBanners(10).catch(() => {
                // Keep the first-paint banners if the follow-up request fails
            });
        };

        const fetchInitial = async () => {
            setLoadingBanners(true);
            try {
                await fetchBanners(2);
            } catch {
                if (!cancelled) setBanners([]);
            } finally {
                if (!cancelled) setLoadingBanners(false);
            }
            if (cancelled) return;
            const ric = (window as any).requestIdleCallback as
                | ((cb: () => void, opts?: { timeout: number }) => number)
                | undefined;
            if (typeof ric === "function") {
                idleId = ric(loadRest, { timeout: 2500 });
            } else {
                timeoutId = window.setTimeout(loadRest, 1500);
            }
        };

        fetchInitial();

        return () => {
            cancelled = true;
            removeLcpBannerPreload();
            const cic = (window as any).cancelIdleCallback as ((id: number) => void) | undefined;
            if (idleId !== undefined && typeof cic === "function") {
                cic(idleId);
            }
            if (timeoutId !== undefined) {
                window.clearTimeout(timeoutId);
            }
        };
    }, []);

    React.useEffect(() => {
        if (!banners.length) return;
        const interval = setInterval(() => {
            setCarouselIndex((prev) => (prev + 1) % banners.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [banners.length]);

    useEffect(() => {
        const measureAppBarHeight = () => {
            if (appBarRef.current) {
                setAppBarHeight(appBarRef.current.offsetHeight);
            }
        };
        measureAppBarHeight();
        window.addEventListener("resize", measureAppBarHeight);
        return () => window.removeEventListener("resize", measureAppBarHeight);
    }, [bannerDismissed]);

    useEffect(() => {
        const fetchData = async () => {
            const commonParams = {
                start: 0,
                length: 100,
                IsChildLiterature: false,
                categoryId: '',
                authorId: '',
                search: '',
                sort: '',
                langId: localStorage.getItem('lan') || 'en',
                isSpecial: false,
            };

            if (openSubjectDiv) {
                if (subjects.length > 0) return;
                setLoadingSubjects(true);
                loadingStartSubjects.current = Date.now();
                try {
                    const response = await SubjectService.getSubjects('', 0, 100);
                    if (response?.status && response?.result && Array.isArray(response.result.items)) {
                        setSubjects(response.result.items);
                    } else {
                        setSubjects([]);
                    }
                } catch (error) {
                    setSubjects([]);
                } finally {
                    const elapsed = Date.now() - loadingStartSubjects.current;
                    const delay = Math.max(0, MIN_SKELETON_MS - elapsed);
                    setTimeout(() => setLoadingSubjects(false), delay);
                }
            } else if (openCategoriesDiv) {
                if (categories.length > 0) return;
                setLoadingCategories(true);
                setLoadingAudios(true);
                setLoadingPravachans(true);
                setLoadingVideos(true);
                setLoadingArticles(true);

                try {
                    const categoriesResponse = await BooksService.getCategories(commonParams.langId);
                    if (categoriesResponse?.status && Array.isArray(categoriesResponse.result)) {
                        setCategories(categoriesResponse.result);
                    } else {
                        setCategories([]);
                    }

                    //   const magazinesResponse = await GeetGovindServices.getAllMagazines(                                   
                    //         commonParams.langId, commonParams.start, commonParams.length            
                    //   )

                    //     if (magazinesResponse?.status && Array.isArray(magazinesResponse.result)) {
                    //         setMagazine(prev => [...prev, ...magazinesResponse.result]);
                    //     } else {
                    //         setMagazine([]);
                    //     }

                    const kalyanResponse = await KalyansService.getCategories(localStorage.getItem("lan") || "en");
                    if (kalyanResponse?.status && kalyanResponse?.result && Array.isArray(kalyanResponse.result)) {
                        setKalyans(kalyanResponse.result);
                    } else {
                        setKalyans([]);
                    }

                    const kalpataruResponse = await KalpataruService.getCategories(localStorage.getItem("lan") || "en");
                    if (kalpataruResponse?.status && kalpataruResponse?.result && Array.isArray(kalpataruResponse.result)) {
                        setKalpataru(kalpataruResponse.result);
                    } else {
                        setKalpataru([]);
                    }

                    const vivekVaniResponse = await VivekvaniServices.getCategories(localStorage.getItem("lan") || "en");

                    if (vivekVaniResponse?.status && vivekVaniResponse?.result && Array.isArray(vivekVaniResponse.result.items)) {
                        setVivekVani(vivekVaniResponse.result.items);
                    } else {
                        setVivekVani([]);
                    }

                    const audioResponse = await AudioService.getAudioCategories();
                    if (audioResponse?.status && audioResponse?.result && Array.isArray(audioResponse.result)) {
                        setAudios(audioResponse.result);
                    } else {
                        setAudios([]);
                    }

                    const pravachanResponse = await PravachanService.getPravachanAuthorCount(commonParams.langId);
                    if (pravachanResponse?.status && pravachanResponse?.result && Array.isArray(pravachanResponse.result)) {
                        setPravachans(pravachanResponse.result);
                    } else {
                        setPravachans([]);
                    }

                    const videoResponse = await VideoService.getCategories();
                    if (videoResponse?.status && videoResponse?.result && Array.isArray(videoResponse.result)) {
                        setVideos(videoResponse.result);
                    } else {
                        setVideos([]);
                    }

                    const articlesResponse = await ArticlesService.getarticlesCategory(
                        localStorage.getItem('lan') || 'en'
                    );
                    if (articlesResponse?.status && articlesResponse?.result && Array.isArray(articlesResponse.result)) {
                        setArticles(articlesResponse.result);
                    } else {
                        setArticles([]);
                    }
                } catch (error) {
                    setCategories([]);
                    setKalyans([]);
                    setKalpataru([]);
                    setVivekVani([]);
                    setAudios([]);
                    setPravachans([]);
                    setVideos([]);
                    setArticles([]);
                } finally {
                    setLoadingCategories(false);
                    setLoadingAudios(false);
                    setLoadingPravachans(false);
                    setLoadingVideos(false);
                    setLoadingArticles(false);
                }
            } else if (openAuthorsDiv) {
                if (authors.length > 0) return;
                setLoadingAuthors(true);
                loadingStartAuthors.current = Date.now();
                try {
                    const pravachanResponse = await PravachanService.getFilters("", "book");
                    const authorsResponse = await PravachanService.getFilters("", "audio");
                    const articlesResponse = await authorService.getFilters(localStorage.getItem("lan") || "en", "article");
                    const videoResponse = await VideoService.getFilters("", "video");
                    if (pravachanResponse?.status && pravachanResponse?.result && Array.isArray(pravachanResponse.result.authors)) {
                        setAuthors(pravachanResponse.result.authors);
                    } else {
                        setAuthors([]);
                    }
                    if (authorsResponse?.status && authorsResponse?.result && Array.isArray(authorsResponse.result.authors)) {
                        setAudioAuthors(authorsResponse.result.authors);
                    } else {
                        setAudioAuthors([]);
                    }
                    if (articlesResponse?.status && articlesResponse?.result && Array.isArray(articlesResponse.result.authors)) {
                        setArticlesAuthors(articlesResponse.result.authors);
                    } else {
                        setArticlesAuthors([]);
                    }
                    if (videoResponse?.status && videoResponse?.result && Array.isArray(videoResponse.result.authors)) {
                        setVideoAuthors(videoResponse.result.authors);
                    } else {
                        setVideoAuthors([]);
                    }
                } catch (error) {
                    setAuthors([]);
                    setAudioAuthors([]);
                    setArticlesAuthors([]);
                    setVideoAuthors([]);
                } finally {
                    const elapsed = Date.now() - loadingStartAuthors.current;
                    const delay = Math.max(0, MIN_SKELETON_MS - elapsed);
                    setTimeout(() => setLoadingAuthors(false), delay);
                }
            } else if (openLanguageDiv) {
                if (languages.length > 0) return;
                setLoadingLanguages(true);
                loadingStartLanguages.current = Date.now();
                try {
                    const languagesResponse = await BooksService.getLanguages("", true, "book");
                    if (languagesResponse?.status && Array.isArray(languagesResponse.result.items)) {
                        setLanguages(languagesResponse.result.items);
                    } else {
                        setLanguages([]);
                    }
                } catch (error) {
                    setLanguages([]);
                } finally {
                    const elapsed = Date.now() - loadingStartLanguages.current;
                    const delay = Math.max(0, MIN_SKELETON_MS - elapsed);
                    setTimeout(() => setLoadingLanguages(false), delay);
                }
            }
            else if (openLatestDiv) {
                if (magazine.length > 0) return;
                const latestBooksResponse = await BooksService.getBooks(
                    0,

                    10,
                    false,

                    "",

                    "",
                    "",

                    "3",


                    "",

                    false
                );
                if (latestBooksResponse?.status && latestBooksResponse?.result && Array.isArray(latestBooksResponse.result.items)) {
                    setMagazine(latestBooksResponse.result.items);

                } else {
                    setMagazine([]);
                }
            }
        };
        if (openSubjectDiv || openCategoriesDiv || openAuthorsDiv || openLanguageDiv || openLatestDiv) {
            fetchData();
        }
    }, [openSubjectDiv, openCategoriesDiv, openAuthorsDiv, openLanguageDiv, openLatestDiv, productFor]);

    const isAnyContentDivOpen = openSubjectDiv || openCategoriesDiv || openAuthorsDiv || openLanguageDiv || openLatestDiv;

    return (
        <>

            <Box sx={{
                bgcolor: "#fff",
                minHeight: "100dvh",
                height: "100dvh",
                display: 'flex',
                flexDirection: 'column',
                overflow: "hidden",
                
            }}>

                <Box ref={appBarRef}>
                    {/* ─── Top App-install Banner ─── */}
                    <Box
                        sx={{
                            overflow: "hidden",
                            maxHeight: bannerDismissed ? "0px" : "110px",
                            transition: "max-height 0.35s ease-in-out, opacity 0.35s ease-in-out",
                            opacity: bannerDismissed ? 0 : 1,
                            ...(bannerDismissed && { height: 0, display: "none" }),
                        }}
                    >
                        <Box
                            sx={{
                                mx: 1.5,
                                my: 1.5,
                                borderRadius: "16px",
                                backgroundColor: "#FEF3E2",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
                                display: "flex",
                                alignItems: "center",
                                px: 1.5,
                                py: 1.2,
                                gap: 1.2,
                                flexShrink: 0,
                                border: "1.5px solid #EDCFA0",
                                position: "relative",
                                zIndex: 10,
                                cursor: "pointer",
                            }}
                            onClick={() => setShowDownloadPopup(true)}
                        >
                            {/* Close button */}
                            <IconButton
                                size="small"
                                onClick={(e) => { e.stopPropagation(); setBannerDismissed(true); }}
                                sx={{ p: 0.3, color: "#999", flexShrink: 0 }}
                            >
                                <CloseIcon sx={{ fontSize: 18 }} />
                            </IconButton>

                            {/* Logo */}
                            <img
                                src={gitasevalogo}
                                alt="Gita Seva"
                                width={52}
                                height={52}
                                style={{
                                    width: 52,
                                    height: 52,
                                    objectFit: "contain",
                                    borderRadius: "12px",
                                    flexShrink: 0,
                                    boxShadow: "0 3px 8px rgba(245,124,0,0.25)",
                                }}
                            />

                            {/* Title + Subtitle */}
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: "14px",
                                        color: "#1a1a1a",
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {t("app_banner_title_tr")}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        color: "#6b6b6b",
                                        lineHeight: 1.3,
                                        mt: 0.3,
                                        // allow 2 lines max, then ellipsis
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    }}
                                >
                                    {t("app_banner_desc_tr")}
                                </Typography>
                            </Box>

                            {/* OPEN APP button */}
                            <Button
                                variant="contained"
                                onClick={(e) => { e.stopPropagation(); window.location.href = "https://gitaseva.org/app"; }}
                                sx={{
                                    bgcolor: "#F57C00",
                                    borderRadius: "10px",
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",   // ← keeps text on one line
                                    minWidth: "unset",
                                    px: 1.8,
                                    py: 0.8,
                                    flexShrink: 0,
                                    boxShadow: "none",
                                    "&:hover": { bgcolor: "#EF6C00", boxShadow: "none" },
                                }}
                            >
                                {t("open_app_tr")}
                            </Button>
                        </Box>
                    </Box>
                    {/* Top App Bar */}
                    <AppBar position="static" sx={{ bgcolor: "#f97316" }}>
                        <Toolbar sx={{ position: "relative", flexDirection: "column", py: 0.5 }}>
                            <Typography
                                sx={{
                                    fontSize: 11,
                                    color: "#ffffffdd",
                                    opacity: 0.9,
                                    textAlign: "center",
                                    width: "100%",
                                    lineHeight: 1.2,
                                }}
                            >
                                {t("shrihari_tr")}
                            </Typography>
                            <Box sx={{ position: "relative", width: "100%", display: "flex", alignItems: "center", padding: "-5px 0px -5px 0px" }}>
                                <IconButton edge="start" color="inherit" onClick={isAnyContentDivOpen ? closeAllContentDivs : () => setOpenDrawer(true)}>
                                    {isAnyContentDivOpen ? (
                                        <ArrowBackIos style={{ opacity: 0.8 }} />
                                    ) : (
                                        <MenuIcon style={{ opacity: 0.8 }} />
                                    )}
                                </IconButton>
                                <Typography
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        right: 0,
                                        textAlign: "center",
                                        pointerEvents: "none",
                                        fontSize: 15,
                                        opacity: 0.9,
                                    }}
                                >
                                    {t("Gita_Seva")}
                                </Typography>
                                <Box sx={{ marginLeft: "auto", display: "flex" }} />
                            </Box>
                        </Toolbar>
                        <hr
                            style={{ width: "100%", backgroundColor: "white" }}
                            className="mt-2"
                        ></hr>
                        {/* Top Menu */}
                        <ul
                            className="d-flex align-items-center w-100 mb-2 justify-content-center text-center"
                            style={{
                                listStyleType: "none",
                                paddingLeft: 25,
                                paddingRight: 25,
                                height: "24px",
                                gap: 20,
                                fontSize: "18px",
                                fontFamily:"chanakyaUni"
                            }}
                        >
                            {[
                                { icon: subjectIcon, label: t("Subject_tr") },
                                { icon: categoriesIcon, label: t("Categoriesss_tr") },
                                { icon: authorIcon, label: t("Authors_tr") },
                                { icon: languageIcon, label: t("Language_tr") },
                                { icon: latestIcon, label: t("Latest_tr") },
                            ].map((item, index, arr) => (
                                <React.Fragment key={index}>
                                    <li
                                        style={{
                                            width: "100%",
                                            backgroundColor: activeMenuItem === item.label ? "#FFEBD5" : "transparent",
                                            padding: "10px 0",
                                            margin: "-20px -20px -20px -20px",
                                            color: activeMenuItem === item.label ? "#f97316" : "white",
                                            fontWeight: activeMenuItem === item.label ? "bold" : "normal",
                                        }}
                                    >
                                        <div
                                            className="d-flex flex-column align-items-center"
                                            onClick={() => handleNavigation(undefined, item.label)}
                                        >
                                            <img
                                                src={item.icon}
                                                height={15}
                                                width={15}
                                                style={{
                                                    filter: activeMenuItem === item.label
                                                        ? "invert(50%) sepia(80%) saturate(2000%) hue-rotate(340deg) brightness(90%) contrast(100%)"
                                                        : "brightness(0) invert(1)"
                                                }}
                                                alt={item.label}
                                            />
                                            <span>{item.label}</span>
                                        </div>
                                    </li>
                                    {index !== arr.length - 1 && (
                                        <li
                                            style={{
                                                width: "1px",
                                                height: "24px",
                                                backgroundColor: "white",
                                                opacity: 0.2,
                                            }}
                                        ></li>
                                    )}
                                </React.Fragment>
                            ))}
                        </ul>
                    </AppBar>
                </Box>

                {/* Overlay Content */}
                {isAnyContentDivOpen && appBarHeight > 0 && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: `${appBarHeight}px`,
                            left: 0,
                            width: '100vw',
                            height: `calc(100dvh - ${appBarHeight}px)`,
                            bgcolor: 'white',
                            zIndex: 1300,
                            overflowY: 'auto',
                            pt: '20px',
                            msOverflowStyle: 'none',
                            scrollbarWidth: 'none',
                            '&::-webkit-scrollbar': {
                                display: 'none',
                            },
                        }}
                    >
                        {openSubjectDiv && (
                            <>
                                {loadingSubjects ? (
                                    <Box sx={{ p: 2 }}>
                                        {Array.from(new Array(8)).map((_, index) => (
                                            <Box key={index} sx={{ borderBottom: "1px solid whitesmoke", padding: 1, fontWeight: 500, fontSize: 18 }}>
                                                <Skeleton variant="text" width={`${85 - (index % 3) * 10}%`} height={28} />
                                            </Box>
                                        ))}
                                    </Box>
                                ) : subjects?.length > 0 ? (
                                    subjects.map((item: any) => (
                                        <div key={item?.id} style={{ width: '100%', borderBottom: '1px solid whitesmoke', padding: 8, fontWeight: 500, fontSize: 18, fontFamily: 'chanakyaUni', display: 'flex', alignItems: 'center', gap: 8 }}
                                            onClick={() => { navigate("/subjectData", { state: { subjectId: item?.id, subjectName: item?.name } }) }}
                                        >
                                            <StarRateIcon sx={{ fontSize: 14, color: '#f97316' }} />
                                            {item?.name}
                                        </div>
                                    ))
                                ) : (
                                    <Typography sx={{ textAlign: 'center', mt: 2, color: 'text.secondary' }}>No Subjects Found.</Typography>
                                )}
                            </>
                        )}

                        {openCategoriesDiv && (
                            <CategoriesAccordion categories={categories} kalyans={kalyans} loadingCategories={loadingCategories} kalpataru={kalpataru} vivekVani={vivekVani} audios={audios} pravachans={pravachans} videos={videos} articles={articles} />
                        )}

                        {openAuthorsDiv && (
                            <AuthorsAccordion
                                Authors={authors}
                                kalyans={kalyans}
                                loadingAuthors={loadingAuthors}
                                kalpataru={kalpataru}
                                vivekVani={vivekVani}
                                articlesAuthors={articlesAuthors}
                                audios={audios}
                                audioAuthors={audioAuthors}
                                pravachans={pravachans}
                                videos={videos}
                                articles={articles}
                                videoAuthors={videoAuthors}
                                setProductFor={setProductFor}
                            />
                        )}
                        {openLanguageDiv && (
                            <LanguageAccordion languages={languages} loadingLanguages={loadingLanguages} />
                        )}
                        {openLatestDiv && (
                            <>

                                <Latest />
                            </>
                        )}
                    </Box>
                )}

                {/* Main content area (Carousel and Options Grid) */}
                {!isAnyContentDivOpen && (
                    <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                        {/* Carousel */}
                        <Box
                            sx={{
                                overflow: "hidden",
                                width: "100%",
                                maxWidth: "100vw",
                                position: "relative",
                                height: { xs: 140, sm: 180, md: 220 },
                                bgcolor: "#fff7ed",
                                flexShrink: 1,
                            }}
                        >
                            {banners.length > 0 ? (
                                <Carousel
                                    autoPlay
                                    interval={4000}
                                    animation="slide"
                                    indicators={true}
                                    navButtonsAlwaysInvisible={true}
                                    sx={{
                                        height: { xs: 140, sm: 180, md: 220 },
                                        '& .CarouselItem': {
                                            height: { xs: 140, sm: 180, md: 220 },
                                        }
                                    }}
                                >
                                    {banners.map((item, index) => (
                                        <Box
                                            key={item.id || index}
                                            onClick={() => {
                                                applyBannerNavigation(navigate, {
                                                    bannerFor: item.bannerFor,
                                                    targetId: item.targetId,
                                                    slug: item.slug,
                                                    name: item.name,
                                                });
                                            }}
                                            sx={{
                                                width: "100%",
                                                height: { xs: 140, sm: 180, md: 220 },
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                position: 'relative',
                                                overflow: 'hidden',
                                                cursor: "pointer",
                                            }}
                                        >
                                            <img
                                                src={item.bannerPath}
                                                alt={item.name || ''}
                                                width="375"
                                                height="140"
                                                fetchPriority={index === 0 ? "high" : undefined}
                                                loading={index === 0 ? "eager" : "lazy"}
                                                onError={() => {
                                                    if (index === 0) {
                                                        clearLcpBannerHint();
                                                    }
                                                }}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    display: 'block',
                                                }}
                                            />
                                        </Box>
                                    ))}
                                </Carousel>
                            ) : loadingBanners ? (
                                <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {/* Reserved slot for banner loading, no spinner to avoid LCP hit */}
                                </Box>
                            ) : (
                                <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>
                                    {t('No banners found')}
                                </Box>
                            )}
                        </Box>

                        {/* Options Grid */}
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gridAutoRows: "1fr",
                                flex: 1,
                                gap: "2px",
                            }}
                        >
                            {options.map((item, index) => (
                                <Box
                                    key={index}
                                    onClick={() => { handleNavigation(item.path, typeof item.label === "string" ? item.label : ""); }}
                                    sx={{
                                        border: "1px solid #f0f0f0",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        color: "#f97316",
                                        p: 1,
                                        cursor: "pointer",
                                        bgcolor: "#fff",
                                        transition: "all 0.3s",
                                        "&:hover": {
                                            backgroundColor: "#fff7ed",
                                            boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                                        },
                                    }}
                                >
                                    <Box mb={0.5}>{item.icon}</Box>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            // fontFamily: `"Mukta", "Noto Sans Devanagari", "Roboto", sans-serif`,
                                            fontFamily:"chanakyaUni",
                                            fontSize: "15.5px",
                                            color: "#444",
                                            fontWeight: 600,
                                            textAlign: "center",
                                            wordWrap: "nowrap",
                                            overflow: 'hidden',
                                            textOverflow: 'nowrap'
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                )}



                {/* Footer */}
                {!isAnyContentDivOpen && (
                    <Box
                        sx={{
                            width: "100%",
                            backgroundColor: "rgb(255, 237, 188)",
                            flexShrink: 0,
                            zIndex: 1200,
                            p: 0,
                        }}
                    >
                        <ul
                            className="d-flex align-items-center w-100 mb-0 justify-content-center text-center"
                            style={{
                                listStyleType: "none",
                                paddingLeft: 25,
                                paddingRight: 25,
                                gap: 20,
                                padding: 8,
                                margin: 0,
                            }}
                        >
                            {[
                                { icon: contactUsIcon, label: t("Contact_tr"), onClick: () => { generateCaptcha(6); setContactModal(true); } },
                                { icon: whatsappIcon, label: t("Social_media_link"), onClick: () => { void handleHomeShareClick(); } },
                                { icon: shareIcon , label: t("shareApp_tr"), onClick: () => setSocialModal(true) },
                                { icon: languageIcon, label: t("Language_tr"), onClick: () => setLanguageModal(true) },
                            ].map((item, index, arr) => (
                                <React.Fragment key={index}>
                                    <li
                                        style={{ width: "100%", cursor: "pointer" }}
                                        onClick={item.onClick}
                                    >
                                        <div className="d-flex flex-column align-items-center">
                                            <img
                                                src={item.icon}
                                                height={15}
                                                width={15}
                                                style={{
                                                    filter:
                                                        "invert(41%) sepia(91%) saturate(2282%) hue-rotate(2deg) brightness(103%) contrast(101%)",
                                                }}
                                                alt={item.label}
                                            />
                                        </div>
                                    </li>
                                    {index !== arr.length - 1 && (
                                        <li
                                            style={{
                                                width: "6px",
                                                height: "18px",
                                                backgroundColor: "#f97316",
                                                opacity: 0.4,
                                            }}
                                        ></li>
                                    )}
                                </React.Fragment>
                            ))}
                        </ul>
                    </Box>
                )}

                <MobileDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} toggleDrawer={toggleDrawer} onContactUs={() => { generateCaptcha(6); setContactModal(true); }} />

                {/* Language Switch Dialog */}
                <Dialog open={languageModal} onClose={() => setLanguageModal(false)}>
                    <Box sx={{ width: 250, textAlign: "center" }}>
                        <Typography variant="h6" sx={{ py: 2 }}>{t("Select_Language_tr")}</Typography>
                        <Divider />
                        {[
                            { key: 'hindi', label: t("language.hindi") },
                            { key: 'english', label: t("language.english") },
                        ].map((option, i, arr) => (
                            <React.Fragment key={option.key}>
                                <ListItem button onClick={() => handleChangeLanguage(option.key)} sx={{ pr: 0 }}>
                                    <DoubleArrowIcon sx={{ fontSize: 18, mr: 1, color: "primary.main" }} />
                                    <ListItemText primary={option.label} />
                                    <ListItemIcon sx={{ ml: "auto", minWidth: 40 }}>
                                        {selectedLanguage === option.key
                                            ? <RadioButtonCheckedIcon color="primary" />
                                            : <RadioButtonUncheckedIcon />}
                                    </ListItemIcon>
                                </ListItem>
                                {i < arr.length - 1 && <Divider />}
                            </React.Fragment>
                        ))}
                        <Divider />
                        <ListItem button onClick={() => setLanguageModal(false)}>
                            <ListItemText primary={t("Cancel_tr")} sx={{ textAlign: 'center' }} />
                        </ListItem>
                    </Box>
                </Dialog>

                {/* Contact Us Slide-Up Panel */}
                {contactModal && (
                    <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1300, display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                        <Box
                            onClick={() => { setContactModal(false); setShowContactSuccess(false); setContactStep(1); }}
                            sx={{
                                position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                bgcolor: "rgba(0,0,0,0.5)",
                                animation: "fadeIn 0.3s ease-out",
                                "@keyframes fadeIn": { from: { opacity: 0 }, to: { opacity: 1 } },
                            }}
                        />
                        <Box
                            sx={{
                                position: "relative", bgcolor: "#fff",
                                borderTopLeftRadius: "16px", borderTopRightRadius: "16px",
                                height: "75vh", overflow: "hidden",
                                display: "flex", flexDirection: "column",
                                animation: "slideUp 0.3s ease-out",
                                "@keyframes slideUp": { from: { transform: "translateY(100%)" }, to: { transform: "translateY(0)" } },
                            }}
                        >
                            <AppBar sx={{ position: "sticky", top: 0, bgcolor: "#f97316", zIndex: 1 }}>
                                <Toolbar>
                                    <IconButton edge="start" color="inherit" onClick={() => { setContactModal(false); setShowContactSuccess(false); setContactStep(1); }}>
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" sx={{ flex: 1 }}>{t("contact_tr")}</Typography>
                                </Toolbar>
                            </AppBar>
                            {showContactSuccess ? (
                                <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", p: 3 }}>
                                    <Typography variant="h6" sx={{ color: "#f97316", mb: 2 }}>{t("thank_you_tr")}</Typography>
                                    <Typography>
                                        {localStorage.getItem("language") === "hindi"
                                            ? "हमें आपका संदेश प्राप्त हो गया है। हम आपको जल्द ही दिये गए ई-मेल या मोबाइल नंबर पर संपर्क करेंगे। धैर्य रखने के लिये धन्यवाद।"
                                            : "We have received your message. We will contact you soon on the given email or mobile number. Thank you for being patient."}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ mt: 3, bgcolor: "#f97316", "&:hover": { bgcolor: "#e65c00" } }}
                                        onClick={() => { setContactModal(false); setShowContactSuccess(false); setContactStep(1); }}
                                    >
                                        {t("close_tr")}
                                    </Button>
                                </Box>
                            ) : (
                                <>
                                    <Box ref={contactScrollRef} sx={{ flex: 1, overflow: "auto", p: 3, pt: 1 }}>
                                        {contactStep === 1 ? (
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                    {localStorage.getItem("language") === "hindi" ? "संपर्क का प्रकार चुनें" : "Select Contact Type"}
                                                </Typography>
                                                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, overflow: "auto", maxHeight: "calc(75vh - 180px)" }}>
                                                    {contactTypes.map((type, i) => (
                                                        <React.Fragment key={type.value}>
                                                            {i > 0 && <Divider />}
                                                            <ListItemButton
                                                                selected={contactData.contactType === type.value}
                                                                onClick={() => setContactData(prev => ({ ...prev, contactType: type.value }))}
                                                                sx={{ py: 0.5 }}
                                                            >
                                                                <ListItemIcon sx={{ minWidth: 36 }}>
                                                                    <DoubleArrowIcon sx={{ fontSize: 18, color: "#f97316" }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={t(type.labelKey)} />
                                                                <ListItemIcon sx={{ minWidth: 36 }}>
                                                                    {contactData.contactType === type.value
                                                                        ? <RadioButtonCheckedIcon color="primary" />
                                                                        : <RadioButtonUncheckedIcon />}
                                                                </ListItemIcon>
                                                            </ListItemButton>
                                                        </React.Fragment>
                                                    ))}
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <IconButton onClick={() => setContactStep(1)} size="small">
                                                        <ArrowBackIos fontSize="small" />
                                                    </IconButton>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                        {t(contactTypes.find(c => c.value === contactData.contactType)?.labelKey || "generalQuery_tr")}
                                                    </Typography>
                                                </Box>
                                                {localStorage.getItem("UserName") ? (
                                                    <TextField label={t("Name_tr")} value={contactData.name} disabled fullWidth inputRef={nameRef} />
                                                ) : (
                                                    <TextField label={t("Name_tr")} value={contactData.name} inputRef={nameRef}
                                                        onChange={(e) => { setContactError(prev => ({ ...prev, name: undefined })); setContactData(prev => ({ ...prev, name: e.target.value })); }}
                                                        error={!!contactError.name} helperText={contactError.name} fullWidth
                                                    />
                                                )}
                                                {localStorage.getItem("Phone") ? (
                                                    <TextField label={t("Mobile_No_tr")} value={contactData.phoneNumber} disabled fullWidth inputRef={numberRef} />
                                                ) : (
                                                    <TextField label={t("Mobile_No_tr")} type="number" value={contactData.phoneNumber} inputRef={numberRef}
                                                        onChange={(e) => { setContactError(prev => ({ ...prev, number: undefined })); if (e.target.value.length <= 10) setContactData(prev => ({ ...prev, phoneNumber: e.target.value })); }}
                                                        error={!!contactError.number} helperText={contactError.number} fullWidth
                                                    />
                                                )}
                                                <TextField label={t("E_Mail_tr")} type="email" value={contactData.email} inputRef={emailRef}
                                                    disabled={localStorage.getItem("EmailIdSe") === "true"}
                                                    onChange={(e) => { setContactError(prev => ({ ...prev, email: undefined })); setContactData(prev => ({ ...prev, email: e.target.value })); }}
                                                    error={!!contactError.email} helperText={contactError.email} fullWidth
                                                />
                                                <TextField label={t("your_suggestions_tr")} multiline rows={4} inputRef={messageRef}
                                                    value={contactData.messageContent}
                                                    onChange={(e) => { setContactError(prev => ({ ...prev, note: undefined })); setContactData(prev => ({ ...prev, messageContent: e.target.value })); }}
                                                    onFocus={handleMessageFocus}
                                                    error={!!contactError.note} helperText={contactError.note} fullWidth
                                                />
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <Typography sx={{ textDecoration: "line-through", fontSize: "20px", fontWeight: "bold" }}>{compareCaptcha}</Typography>
                                                    <TextField placeholder="Enter Captcha" value={captchaValue} inputRef={captchaRef}
                                                        onChange={(e) => { setContactError(prev => ({ ...prev, captcha: undefined })); setCaptchaValue(e.target.value); }}
                                                        error={!!contactError.captcha} helperText={contactError.captcha} sx={{ flex: 1 }}
                                                    />
                                                    <Button onClick={() => generateCaptcha(6)} sx={{ minWidth: "auto" }}>↻</Button>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                    <Box sx={{ p: 3, pt: 0 }}>
                                        <Button variant="contained" fullWidth
                                            sx={{ bgcolor: "#f97316", "&:hover": { bgcolor: "#e65c00" }, py: 1.5 }}
                                            onClick={contactStep === 1 ? () => setContactStep(2) : handleContactSubmit}
                                        >
                                            {contactStep === 1 ? t("next_tr") : t("send_tr")}
                                        </Button>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Box>
                )}

                {/* Social Media Dialog */}
                <Dialog
                    open={socialModal}
                    onClose={() => setSocialModal(false)}
                    PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
                >
                    <Box sx={{ textAlign: "center", p: 2 }}>
                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>{t("Social_media_link")}</Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 2, py: 1 }}>
                            {[
                                { icon: youtubeIcon, label: t("YouTube_tr"), url: "https://www.youtube.com/gitasevaapp" },
                                { icon: facebookIcon, label: t("Facebook_tr"), url: "https://www.facebook.com/gitasevatrust" },
                                { icon: twitterIcon, label: t("Twitter_tr"), url: "https://x.com/gitasevaapp" },
                                { icon: instagramIcon, label: t("Instagram_tr"), url: "https://www.instagram.com/gitasevatrust" },
                                { icon: whatsappGroupIcon, label: "WhatsApp", url: "https://www.whatsapp.com/channel/0029VaG8EhS9Bb5trESdPZ05" },
                            ].map((item, i) => (
                                <Box
                                    key={i}
                                    onClick={() => window.open(item.url, "_blank")}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 0.5,
                                        cursor: "pointer",
                                        p: 1,
                                        borderRadius: "12px",
                                        transition: "all 0.2s",
                                        "&:hover": { bgcolor: "#fff7ed", transform: "scale(1.05)" },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 50,
                                            height: 50,
                                            borderRadius: "50%",
                                            bgcolor: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        <img src={item.icon} alt={item.label} style={{ width: 28, height: 28 }} />
                                    </Box>
                                    <Typography variant="caption" sx={{ fontWeight: 500, color: "#444", fontSize: "11px" }}>
                                        {item.label}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        <Button
                            fullWidth
                            variant="outlined"
                            sx={{ mt: 1, borderColor: "#f97316", color: "#f97316", "&:hover": { borderColor: "#e65c00", bgcolor: "#fff7ed" } }}
                            onClick={() => setSocialModal(false)}
                        >
                            {t("Cancel_tr")}
                        </Button>
                    </Box>
                </Dialog>

                <Snackbar
                    open={linkCopiedSnack}
                    autoHideDuration={2500}
                    onClose={() => setLinkCopiedSnack(false)}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                    <Alert
                        onClose={() => setLinkCopiedSnack(false)}
                        severity="success"
                        sx={{ width: "100%" }}
                    >
                        {t("Link_copied_tr") || "Link copied"}
                    </Alert>
                </Snackbar>
            </Box>
        </>
    );
}